import React from "react";
import { Link } from "react-router-dom";
import { ToyCycleLogo } from "./Logo";
import { STRIPE_PUBLISHABLE_KEY } from "../lib/api";

const stripeMode = (() => {
  if (!STRIPE_PUBLISHABLE_KEY) return null;
  if (STRIPE_PUBLISHABLE_KEY.startsWith("pk_live_")) return "live";
  if (STRIPE_PUBLISHABLE_KEY.startsWith("pk_test_")) return "test";
  return null;
})();

export const Footer = () => (
  <footer className="bg-gray-900 text-white py-12 px-6 mt-auto">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <ToyCycleLogo size={42} />
          <span className="font-black text-xl" style={{ fontFamily: 'Outfit' }}>
            Toy<span className="text-[#FF6B6B]">Cycle</span><span className="text-[#4A90E2]">Hub</span>
          </span>
        </div>
        <p className="text-gray-400 text-sm">The safe marketplace for pre-loved toys. Buy, sell, swap, or donate.</p>
      </div>
      <div>
        <h4 className="font-bold uppercase tracking-wide mb-4">Explore</h4>
        <ul className="space-y-2 text-gray-400 text-sm">
          <li><Link to="/marketplace" className="hover:text-white">Marketplace</Link></li>
          <li><Link to="/browse?transaction_type=swap" className="hover:text-white">Swap Toys</Link></li>
          <li><Link to="/browse?is_donation=true" className="hover:text-white">Free Donations</Link></li>
          <li><Link to="/learning" className="hover:text-white">Learning Center</Link></li>
          <li><Link to="/pricing" className="hover:text-white">Pricing & Plans</Link></li>
          <li><Link to="/get-the-app" className="hover:text-white" data-testid="footer-get-app-link">Get the mobile app</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-bold uppercase tracking-wide mb-4">Support</h4>
        <ul className="space-y-2 text-gray-400 text-sm">
          <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
          <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact-link">Contact Us</Link></li>
          <li><Link to="/trust" className="hover:text-white" data-testid="footer-trust-link">Buyer Protection</Link></li>
          <li><Link to="/safety" className="hover:text-white">Safety Tips</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-bold uppercase tracking-wide mb-4">Legal</h4>
        <ul className="space-y-2 text-gray-400 text-sm">
          <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
          <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
          <li>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("toycycle:open-cookie-prefs"))}
              className="hover:text-white underline-offset-2 hover:underline"
              data-testid="footer-cookie-prefs"
            >
              Cookie settings
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-8 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-gray-500 text-sm">
      <span>© 2024 ToyCycle Hub. All rights reserved.</span>
      {stripeMode && (
        <span
          data-testid={`stripe-mode-${stripeMode}`}
          title={stripeMode === "live" ? "Live payments enabled" : "Test mode — no real charges"}
          className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs font-bold ${
            stripeMode === "live"
              ? "bg-green-500/15 border-green-500/40 text-green-300"
              : "bg-yellow-500/15 border-yellow-500/40 text-yellow-300"
          }`}
        >
          <span className={`w-2 h-2 rounded-full ${stripeMode === "live" ? "bg-green-400" : "bg-yellow-400"} animate-pulse`} />
          Powered by Stripe · {stripeMode === "live" ? "Live" : "Test"} mode
        </span>
      )}
    </div>
  </footer>
);
